var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetch } from "./utils";
export var getProductCategoryMovements = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var query, result, payload;
    var _c;
    var category_id = _b.category_id, _d = _b.paging, paging = _d === void 0 ? { page: 0, size: 100 } : _d, _e = _b.sorting, sorting = _e === void 0 ? [{ order: "createdAt", by: "desc" }] : _e, filters = _b.filters;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                query = "\n    query ($category_id: Int!, $paging: PagingInput, $sorting: [SortingInputProductCategoryMovements!], $filters: FilterInputProductCategoryMovements) {\n      listProductCategoryMovements(category_id: $category_id, paging: $paging, sorting: $sorting, filters: $filters) {\n        items {\n          id\n          createdAt\n          updatedAt\n          date\n          category_id\n          product_id\n          productName\n          set_id\n          setName\n          count\n          storageOut\n          storageIn\n          comment\n          entity\n          documentId\n          documentNumber\n        }\n        total\n        counters { all }\n      }\n    }\n  ";
                return [4 /*yield*/, fetch({
                        url: "/graphql",
                        method: "POST",
                        data: {
                            query: query,
                            variables: { category_id: category_id, paging: paging, sorting: sorting, filters: filters },
                        },
                    })];
            case 1:
                result = _f.sent();
                payload = (result === null || result === void 0 ? void 0 : result.listProductCategoryMovements) || ((_c = result === null || result === void 0 ? void 0 : result.data) === null || _c === void 0 ? void 0 : _c.listProductCategoryMovements);
                if (!payload) {
                    return [2 /*return*/, { items: [], total: 0, counters: { all: 0 } }];
                }
                return [2 /*return*/, payload];
        }
    });
}); };
